import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const IconOpenOrder = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
      >
        <path
          d="M15 22.75H14C13.59 22.75 13.25 22.41 13.25 22C13.25 21.59 13.59 21.25 14 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9C4.39 2.75 2.75 4.39 2.75 9V9.98C2.75 10.39 2.41 10.73 2 10.73C1.59 10.73 1.25 10.39 1.25 9.98V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75Z"
          fill={color}
        />
        <path
          d="M13 11.75C12.81 11.75 12.62 11.68 12.47 11.53C12.18 11.24 12.18 10.76 12.47 10.47L16.21 6.72H14C13.59 6.72 13.25 6.38 13.25 5.97C13.25 5.56 13.58 5.22 14 5.22H18.01C18.31 5.22 18.59 5.4 18.7 5.68C18.82 5.96 18.75 6.28 18.54 6.5L13.53 11.53C13.38 11.68 13.19 11.75 13 11.75Z"
          fill={color}
        />
        <path
          d="M18.01 10.74C17.6 10.74 17.26 10.4 17.26 9.99V5.97C17.26 5.56 17.6 5.22 18.01 5.22C18.42 5.22 18.76 5.56 18.76 5.97V9.98C18.76 10.4 18.42 10.74 18.01 10.74Z"
          fill={color}
        />
        <path
          d="M7.85 22.75H5.15C2.49 22.75 1.25 21.51 1.25 18.85V16.15C1.25 13.49 2.49 12.25 5.15 12.25H7.85C10.51 12.25 11.75 13.49 11.75 16.15V18.85C11.75 21.51 10.51 22.75 7.85 22.75ZM5.15 13.75C3.31 13.75 2.75 14.31 2.75 16.15V18.85C2.75 20.69 3.31 21.25 5.15 21.25H7.85C9.69 21.25 10.25 20.69 10.25 18.85V16.15C10.25 14.31 9.69 13.75 7.85 13.75H5.15Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};
